import { render, staticRenderFns } from "./save-doi-paper-popup.html?vue&type=template&id=5c6f73f0&scoped=true&"
import script from "./save-doi-paper-popup.js?vue&type=script&lang=js&"
export * from "./save-doi-paper-popup.js?vue&type=script&lang=js&"
import style0 from "./save-doi-paper-popup.scss?vue&type=style&index=0&id=5c6f73f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6f73f0",
  null
  
)

export default component.exports